/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const newCommentsSchema = z.object({
	qr_show_order_comment: z.boolean(),
	qr_comment_field_name: z.string().nullable(),
	qr_comment_field_placeholder: z.string().nullable(),
	qr_is_order_comment_required: z.boolean(),
	qr_item_comment: z.boolean(),
	kiosk_show_order_comment: z.boolean(),
	kiosk_comment_field_name: z.string().nullable(),
	kiosk_comment_field_placeholder: z.string().nullable(),
	kiosk_is_order_comment_required: z.boolean(),
	kiosk_item_comment: z.boolean(),
});
